module.exports = __webpack_public_path__ + "static/media/shout.79eead7d.png";